import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { graphql, compose } from 'react-apollo'
import { Padding } from '../UI/index'
import PropTypes from 'prop-types'
import { Snackbar } from 'material-ui'
import { NotificationManager } from 'react-notifications'
// Google Places & Maps
import { Marker } from 'react-google-maps'
import { MAP } from 'react-google-maps/lib/constants'
import PlacesAutocomplete from 'react-places-autocomplete'

import setByPath from 'lodash/set'
import getByPath from 'lodash/get'

import { geoSuggestToLocation, getLatLngByAddress } from './../../libs/utils'
import { isWebsite } from './../../libs/validation'

import { TextInput, TextEditor } from '../UI'
import PhotoSlider from './../PhotoSlider'
import Map from './Map'
import _ from 'lodash'

import CREATE_POI_QUERY from './../../graphql/CreatePOI.graphql'
import UPDATE_POI_QUERY from './../../graphql/UpdatePOI.graphql'

const google = window.google

class POIForm extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      address: '',
      place: '',
      defaultPhotoIds: this.props.initialData ? this.props.initialData.defaultPhotoIds : '',
      photos: this.props.initialData ? this.props.initialData.photos : [],
      selectedPhotos: this.props.initialData
        ? [...this.props.initialData.photos, ...new Array(3 - this.props.initialData.photos.length).fill(null)]
        : [null, null, null],
      placeDetails: {},
      locationDetails: {},
      form: this.props.initialData || {
        title: '',
        description: '',
        phone: '',
        website: '',
        place: null,
        location: null,
        photosIds: [],
        workingHours:''
      },
      errors: {
        location: '',
        place: ''
      },
      openNotification: false
    }
  }
  componentWillMount() {
    console.log(this.props)
    if (this.props.initialData) {
      this.onPlaceSelect(this.props.initialData.title)
      const state = {
        selectedPhotos: []
      }

      state.fileName = _.get(this.props.event, 'docs[0].name', '')

      state.selectedPhotos = this.props.initialData.photos.map(photo => {
        let isDefault = false

        if (this.props.initialData.defaultPhoto) {
          isDefault = this.props.initialData.defaultPhoto.id === photo.id
        }

        return { ...photo, isDefault: isDefault }
      })

      state.selectedPhotos.push(...new Array(3 - this.props.initialData.photos.length).fill(null))

      this.setState(state)
    }
  }

  handleTouchTapNotification = () => {
    this.setState({
      openNotification: true
    })
  }

  handleRequestCloseNotification = () => {
    this.setState({
      openNotification: false
    })
  }
  onPlaceChange(place) {
    this.setState({ place }, () => {})
  }

  onAddressChange(address) {
    this.setState({ address })
  }

  onPlaceSelect(place) {
    this.setState({ place }, () => {
      getLatLngByAddress(this.state.place).then(({ center, additionalInfo }) => {
        this.setState(
          {
            center,
            address: additionalInfo.formatted_address,
            errors: {
              ...this.state.errors,
              location: ''
            },
            marker: <Marker position={center} />
          },
          () => {
            const map = this.map.context[MAP]
            const service = new google.maps.places.PlacesService(map)

            service.getDetails(
              {
                placeId: additionalInfo.place_id
              },
              (place, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                  this.setState(
                    {
                      placeDetails: place,
                      locationDetails: place,
                      form: {
                        ...this.state.form,
                        website: place.website || '',
                        phone: place.international_phone_number || '',
                        workingHours:  place.opening_hours ? place.opening_hours.weekday_text: " " || ''
                      }
                    },
                    () => {
                      let photos = this.state.photos.filter(photo => photo.id)

                      if (place.photos) {
                        photos = [...photos, ...place.photos]
                      }

                      this.setState({ photos })
                    }
                  )
                }
              }
            )
          }
        )
      })
    })
  }

  onAddressSelect(address) {
    this.setState({ address }, () => {
      getLatLngByAddress(this.state.address).then(({ center, additionalInfo }) => {
        this.setState(
          {
            center,
            marker: <Marker position={center} />
          },
          () => {
            const map = this.map.context[MAP]
            const service = new google.maps.places.PlacesService(map)

            service.getDetails(
              {
                placeId: additionalInfo.place_id
              },
              (locationDetails, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                  this.setState({ locationDetails })
                }
              }
            )
          }
        )
      })
    })
  }

  _formatPlaceDetails(details) {
    return new Promise((resolve, reject) => {
      getLatLngByAddress(details.formatted_address)
        .then(location => {
          const result = geoSuggestToLocation({
            location: location.center,
            additionalInfo: location.additionalInfo,
            description: '',
            placeId: details.place_id,
            gmaps: {
              address_components: details.address_components
            }
          })
          resolve(result)
        })
        .catch(err => {
          NotificationManager.error(err.message, 'Error', 5000)

          reject()
        })
    })
  }

  onPlacesError(status) {
    if (status !== 'ZERO_RESULTS') {
      console.warn('GOOGLE PLACES ERROR', status)
    }
  }

  onFormFieldChange(id, value, callback) {
    const form = this.state.form
    const newForm = setByPath(form, id, value)

    this.setState(
      {
        form: newForm
      },
      () => {
        if (callback) {
          callback()
        }
      }
    )
  }

  onDefaultPhotoSelect(index) {
    const { selectedPhotos } = this.state
    this.onFormFieldChange('defaultPhotoId', selectedPhotos[index].id, () => {
      this.setState({
        selectedPhotos: selectedPhotos.map((photo, i) => {
          if (photo) {
            photo.isDefault = i === index
          }
          return photo
        })
      })
    })
  }

  onSubmit() {
    const newState = {
      form: {
        ...this.state.form,
        title: getByPath(this.state, 'placeDetails.name', ''),
        photosIds: this.state.selectedPhotos.filter(photo => photo).map(photo => photo.id)
      }
    }
    //console.log("form_" + form);
    Promise.all([this._formatPlaceDetails(this.state.placeDetails), this._formatPlaceDetails(this.state.locationDetails),this.state.form.workingHours]).then(
      ([place, location,workingHours]) => {
        newState.form.place = place
        newState.form.location = location
        //alert(JSON.stringify(workingHours))
        newState.form.workingHours=JSON.stringify(workingHours)
        this.setState(newState, () => {
          if (!this.props.initialData) {
            this.props
              .createPOI({
                variables: { ...newState.form, defaultPhotoIds: newState.form.defaultPhotoId, tripGuruId: this.props.user.id,workingHours:newState.form.workingHours }
              })
              .then(success => {
                this.handleTouchTapNotification()
                this.props.onSave()
              })
              .catch(err => {
                NotificationManager.error(err.message, 'Error', 5000)
              })
          } else {
            this.props
              .updatePOI({
                variables: { ...newState.form, defaultPhotoIds: newState.form.defaultPhotoId, tripGuruId: this.props.user.id,workingHours:newState.form.workingHours }
              })
              .then(success => {
                this.handleTouchTapNotification()
                this.props.onSave()
              })
              .catch(err => {
                NotificationManager.error(err.message, 'Error', 5000)
              })
          }
        })
      }
    )
  }

  renderWorkingHours() {
    const days = getByPath(this.state, 'placeDetails.opening_hours.weekday_text', [])
    
    if (days.length) {
      return (
        <div className="create-poi__working-hours-container">
          <h2 className="create-poi__form-group-label">{this.props.t('working_hours')}</h2>
          {days.map((day, i) => (
            <div key={i} className="create-poi__working-hours">
              {day}
            </div>
          ))}
        </div>
      )
    }

    return null
  }

  render() {
    const { t } = this.props
    const { marker, center, form, errors, photos, selectedPhotos } = this.state

    const placeInputProps = {
      value: this.state.place,
      placeholder: t('places_placeholder'),
      onChange: address => this.onPlaceChange(address)
    }

    const modules = {
      toolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
        ['link', 'image'],
        ['clean']
      ]
    }

    const formats = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image']

    const locationInputProps = {
      value: this.state.address,
      placeholder: t('location_placeholder'),
      onChange: address => this.onAddressChange(address)
    }

    const locationOptions = {
      types: ['address']
    }

    const classNames = {
      root: 'col-sm-9',
      input: 'form-control create-poi__form-input',
      autocompleteContainer: 'create-poi__autocomplete-container'
    }

            /*
            <TextAreaInput
              id="description"
              maxChars={4000}
              onChangeExternal={(id, props) => this.onFormFieldChange(id, props)}
              initialValue={this.state.form.description}
              placeholder={t('description_placeholder')}
            />
            */

    return (
      <Padding size="24px">
        <div className="create-poi ">
          <h1>{t('page_title')}</h1>
          <hr />
          <div className="form-horizontal create-poi__form-container">
            <h2 className="create-poi__form-group-label">{t('find_poi')}</h2>

            <div className="form-group">
              <label htmlFor="location" className="create-poi__form-label col-md-3 control-label">
                {t('places_label')}
              </label>
              <PlacesAutocomplete
                inputProps={placeInputProps}
                //options={placeOptions}
                onError={status => this.onPlacesError(status)}
                onSelect={(address, placeId) => this.onPlaceSelect(address, placeId)}
                classNames={classNames}
              />
              <div className="col-md-3" />
              <div className="col-md-9">
                <small className="text-danger">{!!errors.place && errors.place}</small>
              </div>
            </div>
            
            <TextInput
              label={t('link_label')}
              labelClass="create-poi__form-label col-md-3 control-label"
              inputWrapperClass="col-md-9"
              id="website"
              extraClass="form-control create-poi__form-input"
              placeholder={t('link_placeholder')}
              initialValue={form.website}
              isGroup={true}
              validationFuncs={[isWebsite]}
              onChangeExternal={(id, value) => this.onFormFieldChange(id, value)}
            />

            <div className="form-group">
              <label htmlFor="location" className="create-poi__form-label col-md-3 control-label">
                {t('location_label')}
              </label>
              <PlacesAutocomplete
                inputProps={locationInputProps}
                options={locationOptions}
                onError={status => this.onPlacesError(status)}
                onSelect={(address, placeId) => this.onAddressSelect(address, placeId)}
                classNames={classNames}
              />
              <div className="col-md-3" />
              <div className="col-md-9">
                <small className="text-danger">{!!errors.location && errors.location}</small>
              </div>
            </div>

            <Map
              containerElement={<div className="google-map__container" />}
              mapElement={<div className="google-map__element" />}
              createRef={map => {
                this.map = map
              }}
              center={center}
              marker={marker}
            />

            <TextInput
              label={t('phone_label')}
              labelClass="create-poi__form-label col-md-3 control-label"
              inputWrapperClass="col-md-9"
              id="phone"
              isGroup={true}
              extraClass="form-control create-poi__form-input"
              placeholder={t('phone_placeholder')}
              initialValue={form.phone}
              onChangeExternal={(id, value) => this.onFormFieldChange(id, value)}
            />
          </div>
          <hr />

          <div className="form-horizontal create-poi__form-container">
            <h2 className="create-poi__form-group-label">{t('description_label')}</h2>
            <div className="create-poi__example-container">
              <i className="icon-flag create-poi__example-icon" />
              <span className="create-poi__example-text">{t('description_example')}</span>
            </div>

            <TextEditor
              id="editor"
              value={this.state.form.description}
              placeholder={t('description_placeholder')}
              onChange={(content, delta, source, editor) => {
                this.onFormFieldChange('description', content)
              }}
            />

          </div>
          <hr />

          <PhotoSlider
            label={t('add_photo')}
            photos={photos}
            selected={selectedPhotos}
            onSelect={selectedPhotos => this.setState({ selectedPhotos }, () => {})}
            onPhotosAdd={photos => this.setState({ photos })}
            onDefaultPhotoSelect={photo => this.onDefaultPhotoSelect(photo)}
          />

          <hr />
         
          <div className="create-poi__form-container">{this.renderWorkingHours()}</div>

          <button className="btn create-poi__submit-btn" onClick={() => this.onSubmit()}>
            {t('save_and_exit')}
          </button>
          <Snackbar
            open={this.state.openNotification}
            message="POI Created"
            autoHideDuration={2000}
            onRequestClose={this.handleRequestClose}
          />
        </div>
      </Padding>
    )
  }
}

export default compose(
  graphql(CREATE_POI_QUERY, {
    name: 'createPOI',
    options: props => ({
      variables: {
        tripGuruId: _.get(props, 'user.id', '')
      }
    })
  }),
  graphql(UPDATE_POI_QUERY, {
    name: 'updatePOI',
    options: props => ({
      variables: {
        tripGuruId: _.get(props, 'user.id', '')
      }
    })
  })
)(POIForm)



// WEBPACK FOOTER //
// src/components/POIForm/index.js